'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'starship-freighter';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e03a';
var svgPathData = 'M379.9 337.7l-60-77.7c.1-1.3 .1-2.7 .1-4 0-53-43-96-96-96s-96 43-96 96c0 47.6 34.6 87 80 94.7l58.8 76.1c-13.7 3.4-28 5.2-42.8 5.2-97.2 0-176-78.8-176-176S126.8 80 224 80 400 158.8 400 256c0 29.5-7.3 57.3-20.1 81.7zM443.6 368L418 368c15.3-26.4 25.3-56.2 28.7-88l81.3 0 0 55.2-84.4 32.8zM409.8 130.9l118.2 46 0 55.2-81.3 0c-4-37.2-17-71.6-36.9-101.1zM512 392.9l64-24.9 0-224-228.4-88.8C308.2 39.9 266.3 32 224 32 100.3 32 0 132.3 0 256S100.3 480 224 480c26 0 51.9-3 77.1-8.8 4.7 6 15.2 19.7 31.5 40.8l179.4 0 0-119.1zM176 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM349 454.7l-85.8-111c14.9-6.7 27.8-17.1 37.5-30l79.1 102.3 84.2 0 0 48-107.8 0-7.2-9.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarshipFreighter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;